import React from "react";
import { Phone } from "lucide-react";
import { FIRM } from "@/data/site";
import { motion } from "framer-motion";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";

export default function FloatingButtons() {
  return (
    <div className="fixed right-4 md:right-6 bottom-6 z-40 flex flex-col gap-3">
      <motion.a
        initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 1.4, duration: 0.6 }}
        href={FIRM.whatsapp} target="_blank" rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-105 transition"
        data-testid="fab-whatsapp"
      >
        <WhatsAppIcon className="h-6 w-6 md:h-7 md:w-7" />
      </motion.a>
      <motion.a
        initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 1.55, duration: 0.6 }}
        href={`tel:${FIRM.phoneRaw}`}
        aria-label="Call us"
        className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-navy text-ivory grid place-items-center shadow-lg hover:scale-105 transition"
        data-testid="fab-call"
      >
        <Phone className="h-5 w-5 md:h-6 md:w-6" />
      </motion.a>
    </div>
  );
}
